//main setting file
import './polyfill'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import cookie from 'browser-cookies'
import moment from 'moment-timezone'
import App from './App'
import router from './router/index'

import VueNotifications from 'vue-notifications'
import VueJsonp from 'vue-jsonp'
import Vuelidate from 'vuelidate'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
import { create, all } from 'mathjs';

import config from '@/config/global'

import VueI18n from 'vue-i18n';
import zh_TW from './locales/zh_TW.json';
import en from './locales/en.json';

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

const math = create(all, {});

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

const Store = () => {

	let type_mapping = {
		'adminuser':'object',
		'user':'object'
	};

	return {
		'$get': (name) => {

			var _t = type_mapping[name] || 'string';
			var _v = cookie.get(name);

			if(_t === 'object'){
				_v = JSON.parse(_v);
			}

			return _v;
		},
		'$set': (name, value) => {

			var _t = typeof value;
			
			type_mapping[name] = _t;

			if(_t === 'object'){
				value = JSON.stringify(value);
			}

			cookie.set(name, value);
		},
		'$del': (name) => {
			cookie.erase(name);
		}
	};

};

const $state = Store();

Vue.use(VueNotifications, options)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueJsonp, 3000);//3 seconds to timeout
Vue.use(VueI18n);

const messages = {
	zh_TW,
	en
};

const i18n = new VueI18n({
	locale: 'zh_TW',
	messages,
});

const MyPi = (Vue, options) => {
	let _video = null;

	Vue.mixin({
		methods: {
			setVideo(video){
				_video = video;
			},
			getVideo(){
				return _video;
			},
		}
	});

	Vue.directive('focus', {
		inserted: (el) => {
			el.focus();
		}
	});

	Vue.filter('capitalize', function (value) {
		if (!value) return '';
		value = value.toString();
		return value.charAt(0).toUpperCase() + value.slice(1);
	});

	Vue.filter('kwh', function (value) {
		if (!value) return 0 + i18n.t('unit_kwh');
		//value = parseFloat(parseInt(value)).toFixed(2);
		value = parseFloat(value).toFixed(2);
		return value + i18n.t('unit_kwh');
	});

	Vue.filter('kw', function (value) {
		if (!value) return 0 + 'w';
		//value = parseFloat(parseInt(value)).toFixed(2);
		value = parseFloat(value).toFixed(2);
		return value + 'w';
	});

	Vue.filter('dateonly', function (value) {
		if (!value) '';
		return value.toString().substring(0, 10);
	});

	Vue.filter('htime', function(value){
		if (!value) return 'N/A';
		let time = moment(parseInt(value)*1000).tz(config.timezone).format('MM/DD HH:mm');
		return time;
	});

	Vue.filter('timedisplay', function(value){
		if (!value) return 'N/A';
		let time = moment(value, 'YYYY-MM-DD HH:mm:ss').tz(config.timezone).format('MM/DD HH:mm');
		return time;
	});

	Vue.filter('htimes', function(value){
		if (!value) return 'N/A';
		let time = moment(parseInt(value)*1000).tz(config.timezone).format('MM/DD HH:mm:ss');
		return time;
	});

	Vue.filter('round', function(value){
		if (isNaN(value)) return '';
		return parseFloat(Math.round(value)).toFixed(0);
	});

	Vue.filter('roundAbs', function(value){
		if (isNaN(value)) return '';
		if (value <= 0) {
			return 0;
		}
		return parseFloat(Math.round(Math.abs(value))).toFixed(0);
	});

	Vue.filter('dn', function(value){ // display number
		if (isNaN(value)) return '';
		return math.format(value, {notation: "fixed", precision: 2});
	});

	Vue.filter('interval', function(value){
		if (!value || isNaN(value)) return '';

		if(value < 60){
			return value + i18n.t('unit_sec');
		}

		if(value >= 60 && value < 3600){
			return Math.round(value/60) + i18n.t('minute');
		}

		if(value >= 3600){
			return Math.round(value/3600) + i18n.t('hour');
		}		
	});

	Vue.filter('timeStr', function(seconds){
		if(!seconds || isNaN(seconds)){
			return '0' + i18n.t('second');
		}

		let d = Math.floor(seconds / (3600*24));
		let h = Math.floor(seconds % (3600*24) / 3600);
		let m = Math.floor(seconds % 3600 / 60);
		let s = Math.floor(seconds % 60);

		let dDisplay = d > 0 ? (d + i18n.t('unit_day')) : "";
		let hDisplay = h > 0 ? (h + i18n.t('unit_hour')) : "";
		let mDisplay = m > 0 ? (m + i18n.t('unit_min')) : "";
		let sDisplay = s > 0 ? (s + i18n.t('unit_sec')) : "";

		return dDisplay + hDisplay + mDisplay + sDisplay;
	});

	Vue.filter('momentDis', function(seconds){
		return moment(parseInt(seconds)).tz(config.timezone).format('YYYY-MM-DD HH:mm');
	});

	Vue.prototype.$moment = moment;
	Vue.prototype.$state  = $state;
	Vue.prototype.$math = math;
};

Vue.use(MyPi);
  
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: {
    App
  }
});